import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SyncProcessorService } from '@vending/sync-engine-client';
import { QueueEntry } from '@vending/sync-engine-client/lib/models/queueEntry';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { TimelogCorrectionModel } from 'src/app/models/system/timelog-correction';
import { ErrorService } from 'src/packages/mitsBasics';
import { EventsService } from 'src/packages/mitsBasics';
import { OfflineDataService } from 'src/packages/mitsBasics';

@Injectable({
  providedIn: 'root',
})
export class TimelogCorrectionService extends OfflineDataService<TimelogCorrectionModel> {
  constructor(
    public indexedDBService: NgxIndexedDBService,
    public syncProcessor: SyncProcessorService,
    public http: HttpClient,
    public errorService: ErrorService,
    public events: EventsService
  ) {
    super(
      indexedDBService,
      syncProcessor,
      'System::TimelogCorrection',
      http,
      errorService,
      events,
      'system/timelog_corrections/',
      'system_timelog_correction',
      ['created_at', 'updated_at', 'remote_id'],
      [],
      undefined,
      true
    );
  }

  async findQueue(id: any): Promise<QueueEntry<TimelogCorrectionModel>> {
    return await this.queueService.getQueuedId(id);
  }

  async updateQueue(obj: any): Promise<number> {
    return await this.queueService.updateQueued(obj);
  }

  /**
   * Name des Icons für die Klasse
   * @return {string}
   */
  public get iconName(): string {
    return 'hourglass-outline';
  }
}
